"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const detect_utils_1 = require("@/common/detect_utils");
const components_1 = require("@/common/components");
const ProfileSettingDialog_1 = __importDefault(require("@/common/components/ProfileSettingDialog"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1() {
    const [{ channel_id, profile_img_url, nickname, uid }] = (0, recoil_1.useRecoilState)(userInfoState_1.default);
    const activeProfile = {
        activate: true,
        id: channel_id,
        uid: String(uid),
        name: nickname,
        thumbnail: profile_img_url,
    };
    const [showProfileSettingDialog, setShowProfileSettingDialog] = (0, react_1.useState)(false);
    const openProfileSettingDialog = () => setShowProfileSettingDialog(true);
    const closeProfileSettingDialog = () => setShowProfileSettingDialog(false);
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const closeMountedDialog = () => {
        if (!unmountRef.current)
            closeProfileSettingDialog();
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '12px',
                    padding: '16px 16px 12px',
                    paddingTop: '16px',
                } }, { children: [(0, jsx_runtime_1.jsx)("label", Object.assign({ role: "button", css: { cursor: 'pointer' }, onClick: () => {
                            window.location.href = `/@${uid}`;
                        } }, { children: (0, jsx_runtime_1.jsx)(components_1.RoundImage, Object.assign({ size: 52, src: profile_img_url, altSrc: "/static/homepage/img/nav_profile.svg" }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HomeIconCircleSvg, { css: { position: 'absolute', bottom: '-2.5px', right: '-2.5px' } }) })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            rowGap: '2px',
                        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle3" }, { children: nickname })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { p: 0 }, onClick: openProfileSettingDialog }, { children: (0, jsx_runtime_1.jsx)(svgs_1.EditIconCircleSvg, { css: { width: '24px', height: '24px' } }) }))] })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "text_overflow", css: {
                                    color: 'rgba(0, 0, 0, 0.4)',
                                    fontSize: '14px',
                                    lineHeight: 1.2,
                                    WebkitLineClamp: 2,
                                } }, { children: ["@", uid] }))] })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                            position: 'absolute',
                            top: '16px',
                            right: '16px',
                            flexShrink: 0,
                            columnGap: '4px',
                            p: '5px 10px',
                            border: '1px solid var(--gray-20)',
                            borderRadius: '100px',
                            bgcolor: 'var(--white) !important',
                            color: 'var(--gray-80)',
                        }, onClick: () => {
                            if (window.location.pathname !== '/member/profile/setting') {
                                window.location.href = '/member/profile/setting';
                            }
                        } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('멀티프로필') })) }))] })), (0, jsx_runtime_1.jsx)(ProfileSettingDialog_1.default, { open: showProfileSettingDialog, closeDialog: closeMountedDialog, activeProfile: activeProfile })] }));
}
exports.default = default_1;
